// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 38" enableBackground="new 0 0 38 38" xmlSpace="preserve">
<path color="currentColor" d="M37.53,35.3l-9.14-9.14c2.26-2.76,3.63-6.3,3.63-10.15C32.03,7.17,24.86,0,16.01,0C7.17,0,0,7.17,0,16.01
	s7.17,16.01,16.01,16.01c3.85,0,7.38-1.36,10.14-3.62l9.14,9.13c0.62,0.62,1.62,0.62,2.24,0C38.16,36.92,38.16,35.91,37.53,35.3z
	 M16.08,29.23c-7.26,0-13.15-5.9-13.15-13.15c0-7.25,5.9-13.16,13.15-13.16c7.25,0,13.15,5.91,13.15,13.16
	C29.23,23.33,23.33,29.23,16.08,29.23z"/>
</svg>;
};

export default React.memo(Search);
